import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Dropdown, Tab, Nav, } from "react-bootstrap";
import { get_Puja_Data_Puja } from '../../../store/actions/CommanAction';
import { useDispatch, useSelector } from 'react-redux';
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import swal from "sweetalert";
import DataTable from 'react-data-table-component';
import { customStyles } from '../Utility/Utility';
import { SET__Puja_ID } from '../../../store/Action_Types';
import Modal from 'react-bootstrap/Modal';
import PoojaListAdd from './PoojaListAdd';


const PoojaList = () => {

    const dispatch = useDispatch()
    const PujaGetDataPuja = useSelector((state) => state.feedBackReducer.PujaGetDataPuja);
    const customerID = Number(sessionStorage.getItem('ID'));
    const [IsActive, setIsActive] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [showPoojaAddModal, setShowPoojaAddModal] = useState(false);
    // const [PujaID, setPujaID] = useState('');

    useEffect(() => {
        if (IsActive) {
            dispatch(get_Puja_Data_Puja('1'))
        } else {
            dispatch(get_Puja_Data_Puja('0'))
        }
    }, [IsActive, IsActive]);

    const filterPoojaData = PujaGetDataPuja?.filter(item => {
        const query = searchQuery ? searchQuery.toLocaleLowerCase() : '';
        return (
            (item.PujaName && item.PujaName.toLocaleLowerCase().includes(query)) ||
            (item.PujaDescription && item.PujaDescription.toLocaleLowerCase().includes(query))
        );
    });

    const handleAddAstrologerClick = (row) => {
       
        dispatch({ type: SET__Puja_ID, payload: row?.PujaID });
        setShowPoojaAddModal(true);
    };

    const handleToggleStatusClick = async (PujaID, currentStatus, isActiveValue) => {
        const postData = {
            'PujaID': PujaID,
            'DeleteByUser': customerID,
            IsActive: !currentStatus ? '1' : '0',
        };
        await AddUpdate('Puja/Delete_Puja', postData);
        dispatch(get_Puja_Data_Puja(currentStatus ? '1' : '0'));
        swal('Good job!', `Successfully ${isActiveValue === '1' ? 'Active' : 'Inactive'}`, "success");

    };

    const columns = [
        {
            width: '100px',
            name: 'Image',
            cell: row => (
                <div className="concierge-bx d-flex align-items-center">
                    {
                        row.PujaImage ? (
                            <img
                                className="me-3 rounded"
                                src={`https://${row.PujaImage.replace(/\\/g, "/")}`}
                                alt="User Avatar"
                            />
                        ) : (
                            <span className="me-3 rounded">No Photo</span>
                        )
                    }
                </div>
            ),
            sortable: true
        },
{
  name: 'Name',
  cell: row => {
    const pujaName = row?.PujaName || '';
    const trimmed = pujaName.slice(0, 35);
    const isTruncated = pujaName.length > 35;

    return (
      <div  className="concierge-bx d-flex align-items-center">
        <div>
          <h5 className="fs-16 mb-0 text-nowrap">
            <Link
              to="/PoojaListAdd"
              onClick={() => {
               
                handleAddAstrologerClick(row);
              }}
              className="text-black"
              title={pujaName} // show full name on hover
            >
              {trimmed}{isTruncated && '...'}
            </Link>
          </h5>
        </div>
      </div>
    );
  },
  sortable: true
},


        {
      name: "Total Amount",
      selector: (row) => row.TotalAmt,
      sortable: true,
    },
        {
      name: "Duraction",
      selector: (row) =>`${ row.Durations} mins`,
      sortable: true,
    },
    //  {
    //   name: "Rating",
    //   selector: (row) => row.Rating,
    //   sortable: true,
    // },
        // {
        //     name: 'Description', selector: (row) => row.PujaDescription, sortable: true,
        //     format: (row) => (
        //         <>{row?.PujaDescription ? row?.PujaDescription.substring(0, 50) : ''}{row?.PujaDescription?.length > 40 ? '  . . .' : null} </>
        //     ),
        // },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">

                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.PujaID, true, '0');
                                }}>
                                Inactive
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            )
        }
    ];

    const columns1 = [
     {
            width: '100px',
            name: 'Image',
            cell: row => (
                <div className="concierge-bx d-flex align-items-center">
                    {
                        row.PujaImage ? (
                            <img
                                className="me-3 rounded"
                                src={`https://${row.PujaImage.replace(/\\/g, "/")}`}
                                alt="User Avatar"
                            />
                        ) : (
                            <span className="me-3 rounded">No Photo</span>
                        )
                    }
                </div>
            ),
            sortable: true
        },
{
  name: 'Name',
  cell: row => {
    const pujaName = row?.PujaName || '';
    const trimmed = pujaName.slice(0, 35);
    const isTruncated = pujaName.length > 35;

    return (
      <div  className="concierge-bx d-flex align-items-center">
        <div>
          <h5 className="fs-16 mb-0 text-nowrap">
            <Link
              to="/PoojaListAdd"
              onClick={() => {
               
                handleAddAstrologerClick(row);
              }}
              className="text-black"
              title={pujaName} 
            >
              {trimmed}{isTruncated && '...'}
            </Link>
          </h5>
        </div>
      </div>
    );
  },
  sortable: true
},


        {
      name: "Total Amount",
      selector: (row) => row.TotalAmt,
      sortable: true,
    },
        {
      name: "Duraction",
      selector: (row) =>`${ row.Durations} mins`,
      sortable: true,
    },


        // {
        //     name: 'Description', selector: (row) => row.PujaDescription, sortable: true,
        //     format: (row) => (
        //         <>{row?.PujaDescription ? row?.PujaDescription.substring(0, 50) : ''}{row?.PujaDescription?.length > 40 ? '  . . .' : null} </>
        //     ),
        // },
        // {
        //     name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
        //     cell: row => (
        //         <div style={{ position: 'absolute', top: 4, right: 50 }}>
        //             <Dropdown>
        //                 <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
        //                     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //                         <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        //                         <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        //                         <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        //                     </svg>
        //                 </Dropdown.Toggle>
        //                 <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
        //                     <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
        //                         onClick={() => {
        //                             handleToggleStatusClick(row.PujaID, false, '1');
        //                         }}>
        //                         Activate
        //                     </Dropdown.Item>
        //                 </Dropdown.Menu>
        //             </Dropdown>
        //         </div>
        //     )
        // }
    ];

    return (
        <>
            {/* {PujaGetDataPuja && ( */}

            {/* )} */}
            <Tab.Container defaultActiveKey="All">
                <div className="mt-4  main_card">
                <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Pooja List</h2>
                    <div className='d-flex justify-content-between align-items-center flex-wrap '>
                        <div className="card-action coin-tabs mb-2">
                            <Nav variant="tabs">
                                <Nav.Item as="li" className="nav-item">
                                    <Nav.Link
                                        className={`nav-link ${IsActive ? 'active' : ''}`}
                                        onClick={() => { setIsActive(true); setSearchQuery(''); }}
                                    >
                                        Active
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" className="nav-item">
                                    <Nav.Link
                                        className={`nav-link ${!IsActive ? 'active' : ''}`}
                                        onClick={() => { setIsActive(false); setSearchQuery(''); }}
                                    >
                                        Inactive
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>

                        </div>

                        <Link to="/PoojaListAdd" onClick={(e) => { e.preventDefault(); handleAddAstrologerClick(null); }} className="btn btn-primary font-w600 mb-2 "> Add Pooja
                        </Link>



                        <div className="input-group search-area text-end" >
                            <input
                                type="text"
                                className={`form-control text-dark`}
                                placeholder="Search list..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <span className="input-group-text" >
                                <Link to={"#"}><i className="flaticon-381-search-2"></i></Link>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <Tab.Content>
                                    <Tab.Pane eventKey="All">
                                        <div className="table-responsive">
                                            {
                                                IsActive ?
                                                    <>
                                                        <DataTable
                                                            dense
                                                            data={filterPoojaData}
                                                            columns={columns}
                                                            selectableRowsHighlight
                                                            highlightOnHover
                                                            pagination
                                                            persistTableHead={true}
                                                            noDataComponent={"There are no data to display"}
                                                            customStyles={customStyles}
                                                        />
                                                    </>
                                                    :
                                                    <>
                                                        <DataTable
                                                            dense
                                                            data={filterPoojaData}
                                                            columns={columns1}
                                                            selectableRowsHighlight
                                                            pagination
                                                            persistTableHead={true}
                                                            noDataComponent={"There are no data to display"}
                                                            customStyles={customStyles}

                                                        />
                                                    </>
                                            }

                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </div>
                </div>


            </Tab.Container >

            <Modal
                show={showPoojaAddModal}
                onHide={() => setShowPoojaAddModal(false)}
                size="xl"
                centered
                backdrop="static"
                keyboard={false}
                className="custom-modal-centered border-0"
            >
                <Modal.Header closeButton>
                    <Modal.Title> <h2 className="heading mb-0">Add Pooja</h2></Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto ' }}>
                    <PoojaListAdd onClose={() => setShowPoojaAddModal(false)} modalOpen={showPoojaAddModal} />
                </Modal.Body>
            </Modal>
        </>
    )
}
export default PoojaList